module.exports = __webpack_public_path__ + "static/node-dbd0129de9f6014e511e5eaec3b82704.svg";